import { matchesTerms, termCounts } from './company-match'

const ACTIVE = 'combobox__option--active'
const OPTION = '.combobox__option'

const setup = (root) => {
  const input = root.querySelector('[data-combobox-input]')
  const list = root.querySelector('[data-combobox-list]')
  const hidden = root.querySelector('input[type="hidden"]')

  if (!input || !list || !hidden) return

  const options = Array.from(list.querySelectorAll(OPTION))
  const form = root.closest('form')
  let committed = input.value

  const shown = () => options.filter((option) => !option.hidden)
  const active = () => shown().find((option) => option.classList.contains(ACTIVE))

  const open = () => {
    list.hidden = false
    input.setAttribute('aria-expanded', 'true')
  }

  const close = () => {
    list.hidden = true
    input.setAttribute('aria-expanded', 'false')
  }

  // The first shown row is highlighted the moment the list opens or the filter
  // changes, which is what lets Enter take the first match without arrowing to it.
  const highlight = (option) => {
    options.forEach((other) => other.classList.remove(ACTIVE))
    if (!option) return

    option.classList.add(ACTIVE)
    option.scrollIntoView({ block: 'nearest' })
  }

  const filter = (text) => {
    const counts = termCounts(text)

    options.forEach((option) => {
      option.hidden = !matchesTerms(option.dataset.label, counts)
    })

    highlight(shown()[0])
  }

  const pick = (option) => {
    if (!option) return

    input.value = option.dataset.label
    hidden.value = option.dataset.id
    committed = input.value
    close()
    if (form) form.submit()
  }

  const move = (step) => {
    const rows = shown()
    if (rows.length === 0) return

    const from = rows.indexOf(active())
    const to = Math.min(Math.max(from + step, 0), rows.length - 1)
    highlight(rows[to] || rows[0])
  }

  // Emptied on focus so the whole list is reachable: the field carries the current
  // selection, and filtering by it would open on a list of one. Anything the user
  // does not replace comes back on blur.
  input.addEventListener('focus', () => {
    committed = input.value || committed
    input.value = ''
    filter('')
    open()
  })

  input.addEventListener('input', () => {
    filter(input.value)
    open()
  })

  input.addEventListener('keydown', (event) => {
    switch (event.key) {
      case 'Enter':
        event.preventDefault()
        pick(active() || shown()[0])
        break
      case 'Escape':
        // Cleared and reopened on the whole list, so the search starts over
        // without the field having to be selected and deleted by hand.
        event.preventDefault()
        input.value = ''
        filter('')
        open()
        break
      case 'ArrowDown':
        event.preventDefault()
        open()
        move(1)
        break
      case 'ArrowUp':
        event.preventDefault()
        move(-1)
        break
      case 'Tab':
        close()
        break
    }
  })

  // mousedown, not click: clicking a row blurs the input first, and the blur
  // handler puts the previous selection back before the click ever lands.
  list.addEventListener('mousedown', (event) => {
    event.preventDefault()

    const option = event.target.closest(OPTION)
    if (option) pick(option)
  })

  input.addEventListener('blur', () => {
    close()
    if (input.value === '') input.value = committed
  })

  document.addEventListener('click', (event) => {
    if (!root.contains(event.target)) close()
  })
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-combobox]').forEach(setup)
})
